module.exports = __webpack_public_path__ + "img/6-1.658d4d48.jpg";